/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для отзывов пользователя.
   */
  app.ItemComments = app.ItemPageableCollection.extend({

    model: app.ItemComment,
    fetchCounter: 0,
    sortTypes: ['utility', '-created_at', 'created_at'],
    sort: '-created_at',
    mode: 'server',
    filter: 'null',
    isScroll: false,
    loadItems: true,
    loadFilters: true,
    requestFilters: false,
    itemsLoadParams: ['item_id', 'per-page', 'page'],
    defaults: {
      pageSize: 5,
      page: 1,
      mode: 'server',
      sort: '-created_at',
      expand: 'user,reactions,item_comment_photos,photos_reply',
      f: 'null'
    },
    state: {
      firstPage: 1,
      pageSize: 5,
      order: 0
    },
    url: function () {
      return app.entryScriptName + '/api/v3/item-comment/';
    },
    initialize: function (models, options) {
      if (options && options.defaults && _.isObject(options.defaults)) {
        _.extend(this.defaults, options.defaults);
      }
      if (options && options.user_id){
        this.user_id = options.user_id;
      }
      if (options && options.requestFilters){
        this.requestFilters = options.requestFilters;
      }
      if (options && options.itemModel){
        this.itemModel = options.itemModel;
      }
      Backbone.PageableCollection.prototype.initialize.apply(this, arguments);
      this.requestTypes = [this.REQUEST_TYPE_FILTERS, this.REQUEST_TYPE_ITEMS];
      this.setQueryParams();
      this.listenTo(this, 'sync', this.setFilters);
    },

    /**
     * Устанавливаем фильтры из ответа сервера
     * @param model
     * @param response
     */
    setFilters: function (model, response) {
      if (response._filters){
        app.filterData = response._filters;
        Backbone.trigger('parseFilterData');
      }
    },

    /**
     * Устанавливает парсеры параметров запроса
     */
    setQueryParams: function () {
      var that = this,
          params = {
              item_id: function () {
                  return that.item_id;
              },
              currentPage: 'page',
              pageSize: 'per-page',
              expand: this.defaults.expand,
              sort: function () {
                  return that.sort;
              },
              f: function () {
                  return that.filter;
              },
          };
      if (this.user_id){
          params.user_id = this.user_id;
      }
      this.queryParams = params;
    },
    parseState: function (resp) {
      return {
        totalRecords: resp._meta.totalCount,
        itemsInResponse: resp.items.length,
        hasOwnComment: resp._has_own_comment
      };
    },

    /**
     * Подсчет рейтинга по оценкам в комментариях
     */
    getOverallRating: function () {
      if (this.models.length == 0) {
        return null;
      }
      if (this.state.totalPages > 1 && this.itemModel) {
        return this.itemModel.get('mean_rating');
      }
      var rating = 0,
        counter = 0,
        reviews = this.models;
      for (var review in reviews) {
        if (!reviews[review].id) {
          continue;
        }
        rating += reviews[review].attributes.rating_id;
        counter++;
      }
      return rating / counter;
    },

    /**
     * Установка коллекции reactions в каждой модели
     */
    putReactionsCollections: function () {
      this.models.forEach(function(model) {
        var reactions = new app.Collection(model.get('reactions'), {
          model: app.Reaction,
        });
        model.set({ reactionsCollection: reactions });
      });
    },
  });

})(jQuery);

}.call(window));